module.exports = __webpack_public_path__ + "img/london.7731b0e7.jpg";